var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZigDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#242938",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A41D",
    d: "M92.1177 71.8824L70.9413 97.7647L60.353 81.2941L92.1177 71.8824Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A41D",
    d: "M92.1176 71.8825L76.8235 84.8236L70.9412 97.7648H63.8824V157.765H74.4706L61.5294 163.647L52.1176 183.647H38V71.8825H92.1176Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A41D",
    d: "M74.4708 157.765L52.1178 183.647L42.7061 170.706L74.4708 157.765Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A41D",
    d: "M103.882 71.8822L110.941 88.3528L81.5293 97.7646L103.882 71.8822Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A41D",
    d: "M103.882 71.8822H168.588V97.7646H81.5293L103.882 83.647V71.8822Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A41D",
    d: "M174.471 157.765L152.118 183.647L143.882 168.353L174.471 157.765Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A41D",
    d: "M174.47 157.765L155.647 168.353L152.117 183.647H87.4116V157.765H174.47Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A41D",
    d: "M214.47 46L99.1764 183.647L41.5293 210.706L156.823 71.8824L214.47 46Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A41D",
    d: "M203.883 71.8824L202.706 93.0588L181.53 98.9412L203.883 71.8824Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A41D",
    d: "M218 71.8825V183.647H162.706L179.177 169.53L185.059 157.765H192.118V98.9413H181.53L193.294 88.3531L203.883 71.8825H218Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A41D",
    d: "M185.059 157.765L190.941 175.412L162.706 183.647L185.059 157.765Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigDark);
export default __webpack_public_path__ + "static/media/Zig-Dark.530d6bfe9dd1f30d6a5233c299ac9cfe.svg";
export { ForwardRef as ReactComponent };